module.exports = __webpack_public_path__ + "static/media/Developmenticon07@3x.83a55e93.png";